/**
 * Central registry for Lottie animations.
 * To update an animation: replace the JSON file under src/assets/lottie/ — no component changes needed.
 *
 * | File                         | Used for                          |
 * |------------------------------|-----------------------------------|
 * | rapfire_card_main.json       | Game Zone — Rap Fire game card    |
 * | raphousie_card_main.json     | Game Zone — Rap Housie game card  |
 * | Fire_Main.json               | Rap Fire hero (room list headers) |
 * | housie.json                  | Rap Housie hero (room list)       |
 * | bell-wave.json               | Game Zone notification bell       |
 * | logout_ic.json               | Game Zone logout button           |
 */
import rapFireCardLottie from '../assets/lottie/rapfire_card_main.json';
import rapHousieCardLottie from '../assets/lottie/raphousie_card_main.json';
import rapFireHeroLottie from '../assets/lottie/Fire_Main.json';
import rapHousieHeroLottie from '../assets/lottie/housie.json';
import bellWaveLottie from '../assets/lottie/bell-wave.json';
import logoutLottie from '../assets/lottie/logout_ic.json';

export const LOTTIE_ANIMATIONS = {
  RAP_FIRE_CARD: rapFireCardLottie,
  RAP_HOUSIE_CARD: rapHousieCardLottie,
  RAP_FIRE_HERO: rapFireHeroLottie,
  RAP_HOUSIE_HERO: rapHousieHeroLottie,
  BELL_WAVE: bellWaveLottie,
  LOGOUT: logoutLottie,
};

/** Game Zone dashboard cards — keyed by dashboard game `id`. */
export const GAME_CARD_LOTTIE_BY_ID = {
  rap_fire: LOTTIE_ANIMATIONS.RAP_FIRE_CARD,
  rap_housie: LOTTIE_ANIMATIONS.RAP_HOUSIE_CARD,
};

/** Room-list / select-screen hero icons — keyed by game `id`. */
export const GAME_HERO_LOTTIE_BY_ID = {
  rap_fire: LOTTIE_ANIMATIONS.RAP_FIRE_HERO,
  rap_housie: LOTTIE_ANIMATIONS.RAP_HOUSIE_HERO,
};

export const getGameCardLottie = (gameId) => GAME_CARD_LOTTIE_BY_ID[gameId] ?? null;

export const getGameHeroLottie = (gameId) => GAME_HERO_LOTTIE_BY_ID[gameId] ?? null;
